enum SummaryPageTabEnum {
	productList = 'productList',
	images = 'images',
	security = 'security',
	customTab1 = 'customTab1',
	customTab2 = 'customTab2',
	customTab3 = 'customTab3',
	customTab4 = 'customTab4',
	customTab5 = 'customTab5'
}

export default SummaryPageTabEnum;
